@if (shouldShowControl()) {
  <div gkControlRow>
    <span gkControlLabel [showLabel]="controlConfig.showLabel">
      <gk-translated-label [configLabel]="controlConfig.label"></gk-translated-label>:</span>
      <span gkControlValue [showLabel]="controlConfig.showLabel">
        <a [attr.href]="controlConfig.pathToValue">{{ 'GK.DYNAMIC_LIST.ENTER' | translate }}&nbsp;&#x21E8;</a>
      </span>
    </div>
  }
